module.exports = __webpack_public_path__ + "img/23.d052f8bf.jpg";